/**
 * Converts "13:00:00" / "08:30" to 12-hour Arabic display, e.g. "1:00 م", "8:30 ص".
 */
export function formatStoreTime12h(time) {
  if (time == null || time === "") return "";

  const parts = String(time).trim().split(":");
  const h = Number(parts[0]);
  const rawMinutes = parts[1] ?? "00";

  if (!Number.isFinite(h)) return String(time);

  const minutes = String(rawMinutes).padStart(2, "0").slice(0, 2);
  const hour12 = h % 12 === 0 ? 12 : h % 12;
  const period = h < 12 ? "ص" : "م";

  return `${hour12}:${minutes} ${period}`;
}
